import { useState } from 'react'


function BecomeAseller() {


    const [store, setStore] = useState([{
        logo: ""
    }]);

    const [logo, setLogo] = useState("");

    const [logoLength, setLogoLength] = useState(0);

    const onSelectLogo = (event) => {
        const selectedFiles = event.target.files[0];

        console.log("selectedFiles", selectedFiles);

        setLogo((selectedFiles))

        console.log("logo", logo);

        setLogoLength((selectedFiles.length))

        setStore([{ logo: "" }])

        console.log((selectedFiles))
        // FOR BUG IN CHROME
        event.target.value = "";

    };

    function deleteLogo(image, e) {
        e.preventDefault();
        setLogo("");
        setLogoLength(0)
        setStore([{ logo: "" }])
    }


    return (
        <>
            <section className='become-seller_sec'>
                <div className="container">
                    <div className="card jc-center">
                        <h3>Become a Seller</h3>
                        <form>
                            <div className='mb-5'>
                                <label className="form-label mb-2">Any Certification (if applicable)</label>

                                <div className='profile-image'>
                                    <label className="mb-0">
                                        <div className="overlay">
                                            <span className="icon d-flex justify-content-around align-items-center w-40 text-center">
                                                <div>
                                                    <i className="fas fa-pen"></i>
                                                </div>
                                                {typeof logo !== "undefined" && logo !== "" ?
                                                    <>
                                                        <div onClick={(e) => deleteLogo(logo.image, e)}>
                                                            <i className="fas fa-trash"></i>
                                                        </div>
                                                        <div onClick={(e) => { setStore([{ logo: logo }]); setLogo(""); e.preventDefault(); }}>
                                                            <i className="fas fa-check"></i>
                                                        </div>
                                                    </>
                                                    :
                                                    ""
                                                }
                                            </span>
                                        </div>
                                        {typeof store[0]?.logo != 'undefined' && store[0].logo != "" ?
                                            <>

                                                {
                                                    logoLength === 0 ?
                                                        <p>Upload File</p>
                                                        :
                                                        <p>{logoLength} Uploaded</p>
                                                }
                                            </>
                                            :
                                            <>
                                                {
                                                    logoLength === 0 ?
                                                        <p>Upload File</p>
                                                        :
                                                        <p>Uploading...</p>
                                                }
                                            </>
                                        }
                                        <input type="file" className='form-control' style={{ display: "none" }} onChange={onSelectLogo} />
                                    </label>
                                </div>
                            </div>

                            <button className="btn confirm_btn">Confirm</button>
                        </form>
                    </div>
                </div>
            </section>
        </>
    )
}

export default BecomeAseller